(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.section-header');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};

            this.setHeaderHeight();

            window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

            if (this.headerIsAlwaysSticky) {
                this.header.classList.add('shopify-section-header-sticky');
            };

            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
            

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
            
            this.createObserver();
        }

        setHeaderHeight() {
            document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.closeMenuDisclosure();
            this.closeSearchModal();
        }

        reveal() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
        }

        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
            this.disclosures.forEach(disclosure => disclosure.close());
        }

        closeSearchModal() {
            this.searchModal = this.searchModal || this.header.querySelector('details-modal');
            this.searchModal.close(false);
        }
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ids-questionnaire"] && !Shopify.designMode) return;
  try {
    
  // Initialises every .swyft-consult form on the page. Each lookup is scoped
  // to its own root, so multiple instances don't interfere. Guarded against
  // double-init and re-run on Shopify's theme-editor section load event.
  function swyftInitConsult(scope) {
    if (!scope || scope.dataset.swyftInit === 'true') return;
    scope.dataset.swyftInit = 'true';

    const $ = (sel) => scope.querySelector(sel);
    const $$ = (sel) => scope.querySelectorAll(sel);

    // ─── Chip Toggling ───
    $$('.chip-group').forEach(group => {
      const mode = group.dataset.mode;
      const target = scope.querySelector('#' + group.dataset.target);

      group.querySelectorAll('.chip').forEach(chip => {
        chip.addEventListener('click', () => {
          if (mode === 'single') {
            group.querySelectorAll('.chip').forEach(c => c.classList.remove('selected'));
            chip.classList.toggle('selected');
            const sel = group.querySelector('.chip.selected');
            if (target) target.value = sel ? sel.dataset.value : '';
          } else {
            chip.classList.toggle('selected');
            const vals = [...group.querySelectorAll('.chip.selected')].map(c => c.dataset.value);
            if (target) target.value = vals.join(', ');
          }
        });
      });
    });

    // ─── Unit Toggle ───
    const unitTarget = $('#hid_unit');
    $$('.unit-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        $$('.unit-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        if (unitTarget) unitTarget.value = btn.dataset.unit;
      });
    });

    // ─── File Upload Display ───
    $$('input[type="file"]').forEach(input => {
      input.addEventListener('change', () => {
        const zone = scope.querySelector('#' + input.dataset.zone);
        const list = scope.querySelector('#' + input.dataset.list);
        if (!zone || !list) return;
        list.innerHTML = '';
        if (input.files.length > 0) {
          zone.classList.add('has-files');
          Array.from(input.files).forEach(f => {
            const tag = document.createElement('div');
            tag.className = 'file-tag';
            tag.textContent = f.name;
            list.appendChild(tag);
          });
        } else {
          zone.classList.remove('has-files');
        }
      });
    });

    // ─── Add Link ───
    const links = [];
    const linkInput = $('#linkInput');
    const linksHidden = $('#hid_inspiration_links');
    const linksAdded = $('#linksAdded');

    function addLink() {
      if (!linkInput) return;
      const val = linkInput.value.trim();
      if (!val) return;
      links.push(val);
      if (linksHidden) linksHidden.value = links.join('\n');
      const item = document.createElement('div');
      item.className = 'link-item';
      item.textContent = val;
      if (linksAdded) linksAdded.appendChild(item);
      linkInput.value = '';
    }

    const addLinkBtn = $('#addLinkBtn');
    if (addLinkBtn) addLinkBtn.addEventListener('click', addLink);
    if (linkInput) {
      linkInput.addEventListener('keydown', e => {
        if (e.key === 'Enter') { e.preventDefault(); addLink(); }
      });
    }

    // ─── Validation & Submit ───
    const form = $('#consultationForm');
    if (!form) return;

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      let valid = true;

      const fn = $('#first_name');
      if (!fn.value.trim()) {
        fn.classList.add('invalid');
        $('#err_first_name').classList.add('visible');
        valid = false;
      } else {
        fn.classList.remove('invalid');
        $('#err_first_name').classList.remove('visible');
      }

      const ln = $('#last_name');
      if (!ln.value.trim()) {
        ln.classList.add('invalid');
        $('#err_last_name').classList.add('visible');
        valid = false;
      } else {
        ln.classList.remove('invalid');
        $('#err_last_name').classList.remove('visible');
      }

      const em = $('#email');
      const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRe.test(em.value.trim())) {
        em.classList.add('invalid');
        $('#err_email').classList.add('visible');
        valid = false;
      } else {
        em.classList.remove('invalid');
        $('#err_email').classList.remove('visible');
      }

      if (!valid) {
        fn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      const btn = $('#submitBtn');
      const originalLabel = btn.textContent;
      btn.textContent = 'Sending…';
      btn.disabled = true;

      try {
        const data = new FormData(form);
        const response = await fetch(form.action, {
          method: 'POST',
          body: data,
          headers: { 'Accept': 'application/json' }
        });

        if (response.ok) {
          form.style.display = 'none';
          $('#successCard').classList.add('visible');
          scope.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          btn.textContent = originalLabel;
          btn.disabled = false;
          alert('Something went wrong. Please try again or contact us directly.');
        }
      } catch (err) {
        btn.textContent = originalLabel;
        btn.disabled = false;
        alert('Could not send the form. Please check your connection and try again.');
      }
    });
  }

  function swyftInitAll() {
    document.querySelectorAll('.swyft-consult').forEach(swyftInitConsult);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swyftInitAll);
  } else {
    swyftInitAll();
  }

  // Theme editor: re-init when this section is added or re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    const root = e.target.querySelector('.swyft-consult');
    if (root) swyftInitConsult(root);
  });

  } catch(e) { console.error(e); }
})();
})();
